<!--运行监控-->
<template>
    <div class="operation-monitoring">
        <content-view>
            <template slot="header">
                <div class="pl16 font-weight font-biggest">
                    运行监控
                </div>
            </template>
            <a-spin :spinning="spinning">
                <template v-if="(Boolean(shopId) && String(shopId) !== '-1') || Boolean($route.query.shopId)">
                    <template v-if="shopMonitorInfo.level">
                        <div class="pl32 pr32 pb32 pt32 bg-white operation-monitoring-top flex flex-space-between">
                            <div class="operation-monitoring-top-left">
                                <div class="operation-monitoring-top-left-top flex">
                                    <span class="font-biggest font-weight text-color-85">{{ $route.query.shopName || shopName }}</span>
                                    <span class="text-fail font-big ml8 flex">
                                    <img class="mr8" width="16px" height="19px" :src="opMIcon[shopMonitorInfo.level]" alt="">
                                    <template v-if="shopMonitorInfo.level !== 'ok'">
                                        {{ shopMonitorInfo.effectiveDuration | SEC2DHM }}
                                    </template>
                                </span>
                                </div>
                                <div class="text-color-45">
                                    <template v-if="shopMonitorInfo.level !== 'ok'">
                                        <span>告警时间</span>
                                        <a-divider type="vertical"></a-divider>
                                        <span>{{ shopMonitorInfo.effectiveStart | isEmpty}}</span>
                                    </template>
                                </div>
                            </div>
                            <div class="operation-monitoring-top-right flex">
                                <div class="operation-monitoring-top-right-statistics-block text-center">
                                    <div class="text-color-45">告警业务</div>
                                    <div class="text-fail statistics-number">{{ shopMonitorInfo.criticalNum }}</div>
                                </div>
                                <a-divider type="vertical" class="ml40 mr40" style="height: 50px;"></a-divider>
                                <div class="operation-monitoring-top-right-statistics-block text-center">
                                    <div class="text-color-45">预警业务</div>
                                    <div class="text-warn statistics-number">{{ shopMonitorInfo.warningNum }}</div>
                                </div>
                                <a-divider type="vertical" class="ml40 mr40" style="height: 50px;"></a-divider>
                                <div class="operation-monitoring-top-right-statistics-block text-center">
                                    <div class="text-color-45">正常业务</div>
                                    <div class="text-safe statistics-number">{{ shopMonitorInfo.okNum }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="mt24 pt24 bg-white operation-monitoring-bottom flex flex-align-start">
                            <div class="operation-monitoring-bottom-left">
                                <template v-for="(item, index) in moduleMonitorInfos">
                                    <div :key="item.nodeId" class="operation-monitoring-bottom-left-item pl24 pr16 mb8 flex flex-space-between" :class="activeKey === index ? 'active' : ''" @click="switchType(index)">
                                        <span>{{ item.moduleName }}</span>
                                        <img width="13px" height="15px" :src="opMIcon[item.level]" alt="">
                                    </div>
                                </template>
                            </div>
                            <div class="operation-monitoring-bottom-right">
                                <template v-for="(item, index) in moduleMonitorInfos">
                                    <div :key="item.nodeId" v-show="activeKey === index">
                                        <template v-for="($item, $index) in item.modules">
                                            <div class="operation-monitoring-bottom-right-detail-block" :class="$index === item.modules.length - 1 ? 'no-margin_bottom' : '' ">
                                                <div class="operation-monitoring-bottom-right-detail-block-title font-big">
                                                    <span>{{ $item.moduleName }}</span>
                                                    <span v-if="Boolean($item.criticalNum) || Boolean($item.warningNum)" class="text-fail">（{{ ($item.criticalNum ? $item.criticalNum : 0) + ($item.warningNum ? $item.warningNum : 0) }}）</span>
                                                </div>
                                                <div class="operation-monitoring-bottom-right-detail-block-list text-color-45">
                                                    <template v-for="($$item, $$index) in $item.monitors">
                                                        <a-row class="operation-monitoring-bottom-right-detail-block-list-item">
                                                            <a-col span="7">{{ $$item.businessName }}</a-col>
                                                            <a-col span="7">
                                                                <div class="flex flex-start">
                                                                    <img class="mr8" width="13px" height="15px" :src="opMIcon[$$item.level]" alt="">
                                                                    {{ $$item.level | monitorState }}
                                                                </div>
                                                            </a-col>
                                                            <a-col span="7">
                                                                <template v-if="$$item.level !== 'ok'">
                                                                    持续时长：{{ $$item.effectiveDuration | SEC2DHM }}
                                                                </template>
                                                            </a-col>
                                                            <a-col class="text-right" span="3"><a class="text-primary mr24 action" @click="openDetail(`${item.moduleName}>${$item.moduleName}>${$$item.businessName}`, $$item.nodeId, $$item.level)">查看</a></a-col>
                                                        </a-row>
                                                    </template>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-for="($item, $index) in item.monitors">
                                            <div class="operation-monitoring-bottom-right-detail-block-style2">
                                                <div class="operation-monitoring-bottom-right-detail-block-style2-list text-color-45">
                                                    <a-row class="operation-monitoring-bottom-right-detail-block-style2-list-item">
                                                        <a-col span="7" class="font-big text-color-85">{{ $item.businessName }}</a-col>
                                                        <a-col span="7">
                                                            <div class="flex flex-start">
                                                                <img class="mr8" width="13px" height="15px" :src="opMIcon[$item.level]" alt="">
                                                                {{ $item.level | monitorState }}
                                                            </div>
                                                        </a-col>
                                                        <a-col span="7">
                                                            <template v-if="$item.level !== 'ok' && $item.level !== 'unknown'">
                                                                持续时长：{{ $item.effectiveDuration | SEC2DHM }}
                                                            </template>
                                                        </a-col>
                                                        <a-col class="text-right" span="3"><a class="text-primary mr24 action" @click="openDetail(`${item.moduleName}>${$item.businessName}`, $item.nodeId, $item.level)">查看</a></a-col>
                                                    </a-row>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="pb32 pt32 pl32 pr32 bg-white">
                            <div class="text-center operation-empty pt80 pb80">
                                <img width="222" src="../../assets/image/operation-empty.png" alt="">
                                <div class="mt24" style="color: #babcc2; font-size: 24px;">暂无数据</div>
                            </div>
                        </div>
                    </template>
                </template>
                <a-empty class="pt24 pb24" v-else >
                    <span slot="description" class="font-big22">请切换到各门店查看</span>
                </a-empty>
            </a-spin>
        </content-view>
        <fault-detail-modal ref="faultDetailModal" />
    </div>
</template>

<script>
import FaultDetailModal from '@/components/modules/operation-management/fault-detail-modal.component';
import opMIconOk from '../../assets/image/opM-icon-ok.png';
import opMIconWarning from '../../assets/image/opM-icon-warning.png';
import opMIconCritical from '../../assets/image/opM-icon-critical.png';
import opMIconUnknown from '../../assets/image/opM-icon-unknown.png';
import { mapGetters } from "vuex";
export default {
    name: "OperationMonitoring",
    components: {
        FaultDetailModal
    },
    data() {
        return {
            opMIcon: {
                ok: opMIconOk,
                warning: opMIconWarning,
                critical: opMIconCritical,
                unknown: opMIconUnknown
            },
            activeKey: 0,
            shopMonitorInfo: {},
            moduleMonitorInfos: [],
            spinning: false
        }
    },
    computed: {
        ...mapGetters(["shopId", "shopName"])
    },
    watch: {
        shopId() {
            this.$router.push({name: 'operationMonitoring', query: {}});
            if (this.$route.query.shopId) {
                return false;
            }
            this.getShopMonitorInfo();
        }
    },
    mounted() {
        this.getShopMonitorInfo();
    },
    methods: {
        /**
         * @switchType {callback} 切换监控展示类型。
         */
        switchType(activeKey) {
            this.activeKey = activeKey;
        },
        /**
         * @openDetail {callback} 查看告警详情。
         */
        openDetail(title, nodeId, level) {
            this.$refs.faultDetailModal.open({title, nodeId, level});
        },
        /**
         * @getShopMonitorInfo {method} 获取门店监控信息。
         */
        getShopMonitorInfo() {
            if ((!Boolean(this.shopId) || String(this.shopId) === '-1') && !Boolean(this.$route.query.shopId)) {
                return false;
            }
            this.spinning = true;
            this.$api.operationManagement.getShopMonitorInfo({
                params: {
                    shopId: this.$route.query.shopId ? this.$route.query.shopId : this.shopId
                }
            }).then(res => {
                this.activeKey = 0;
                this.spinning = false;
                this.shopMonitorInfo = res;
                this.moduleMonitorInfos = this.$utils.deepClone(res.moduleMonitorInfos);
            });
        },

    }
}
</script>

<style lang="scss">
    .operation-monitoring {
        .operation-empty {
            background: #fafafa;
            border: 1px solid #e9e9e9;
        }
        .text-warn {
            color: #F3C221;
        }
        .text-safe {
            color: #2FC25B;
        }
        &-top {
            &-left {
                &-top {
                    margin-bottom: 12px;
                }
            }
            &-right {
                &-statistics-block {
                    .statistics-number {
                        font-size: 30px;
                        margin-top: 4px;
                    }
                }
            }
        }
        &-bottom {
            align-items: stretch;
            min-height: 50vh;
            &-left {
                width: 228px;
                user-select: none;
                &-item {
                    cursor: pointer;
                    padding: 10px 0;
                    border-right: 3px solid transparent;
                    &.active {
                        background: rgba(243,194,33,0.10);
                        border-right: 3px solid #F3C221;
                        cursor: default;
                        span {
                            color: #000000;
                        }
                    }
                    &:hover {
                    background: rgba(243,194,33,0.10);
                    border-right: 3px solid #F3C221;
                    span {
                        color: #000000;
                    }
                }
                }
            }
            &-right {
                padding: 0 50px 30px 50px;
                flex: 1;
                border-left: 1px solid #E9E9E9;
                &-detail-block {
                    margin-bottom: 30px;
                    &-title {
                        color: #000000;
                        margin-bottom: 10px;
                    }
                    &-list {
                        &-item {
                            padding: 20px 0;
                            border-bottom: 1px solid #e9e9e9;
                            .action {
                                text-decoration: underline;
                            }
                        }
                    }
                }
                &-detail-block-style2 {
                    &-title {
                        color: #000000;
                        margin-bottom: 10px;
                    }
                    &-list {
                        &-item {
                            padding: 30px 0;
                            border-bottom: 1px solid #e9e9e9;
                            .action {
                                text-decoration: underline;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
